interface CanvasSettings{
    height : number
    width : number
    fps : number 
    refreshInterval : number
}

class CanvasSettingsHolder implements CanvasSettings{
    height = 600
    width = 800
    fps = 12
    refreshInterval = 1

    setDimens(tWidth: number, tHeight: number){
        this.height = tHeight;
        this.width = tWidth;
    }

    setAnimVals(tFps: number, tRefreshInterval: number){
        this.fps = tFps;
        this.refreshInterval = tRefreshInterval;
    }
}

export let canvasSettings = new CanvasSettingsHolder();